import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useInvestorAuth } from '../../context/InvestorAuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const inputStyle = {
  width: '100%',
  height: 48,
  padding: '0 14px',
  borderRadius: 10,
  border: '1px solid #e5e7eb',
  fontSize: 14,
  color: '#111827',
  backgroundColor: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
};

export default function MarketLogin() {
  const navigate = useNavigate();
  const { investorLogin } = useInvestorAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email.trim() || !form.password) {
      setError('Please enter your email and password.');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/market/auth/login`, {
        email: form.email.trim(),
        password: form.password,
      });
      investorLogin(res.data.token, res.data.investor);
      navigate('/market/portal/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Link to="/market" style={{ textDecoration: 'none', display: 'inline-block' }}>
            <img
              src="/doorly-market-logo.png"
              alt="Doorly Market"
              style={{ height: '36px', width: 'auto', display: 'block', margin: '0 auto' }}
            />
          </Link>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '16px 0 4px' }}>Investor Sign In</h1>
          <p style={{ color: '#6b7280', fontSize: 13 }}>Sign in to your DoorlyMarket account.</p>
        </div>

        <div style={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: 16, padding: 28 }}>
          {error && (
            <div style={{ marginBottom: 16, padding: '10px 14px', borderRadius: 10, backgroundColor: '#fff5f6', border: '1px solid #ffd6db', color: '#ff082f', fontSize: 13 }}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} noValidate>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Email</label>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                autoComplete="email"
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: 8 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Password</label>
              <input
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                autoComplete="current-password"
                style={inputStyle}
              />
            </div>
            <div style={{ textAlign: 'right', marginBottom: 18 }}>
              <Link to="/market/forgot-password" style={{ fontSize: 13, color: '#3a6ad9' }}>Forgot password?</Link>
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                height: 48,
                borderRadius: 100,
                border: 'none',
                backgroundColor: '#3a6ad9',
                color: '#fff',
                fontWeight: 700,
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: 13, color: '#6b7280', marginTop: 18 }}>
          Need access? <Link to="/market/register" style={{ color: '#3a6ad9', fontWeight: 600 }}>Apply here</Link>
        </p>
      </div>
    </div>
  );
}
